export const selectDefaultProps = {
  MenuProps: {
    sx: {
      maxHeight: "400px",
    },
  },
};
